import React, { useState } from 'react';
import { FaCogs, FaLightbulb, FaPlus, FaMinus, FaEdit, FaTable, FaChartLine } from "react-icons/fa";
import ArchiveTableModal from '../../components/Archive/ArchiveTableModal';
import ArchiveChartModal from '../../components/Archive/ArchiveChartModal';
import styles from '../../pages/Monitor/Monitor.module.css';
const SensorControlCard = ({
    type,
    index,
    label,
    icon,
    unit,
    data,
    onUpdate,
    customNames = {},
    onSaveCustomName,
    serial,
    token
}) => {
    const { current, settings, triggered } = data;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isEditingName, setIsEditingName] = useState(false);
    const [editedName, setEditedName] = useState('');
    const [isArchiveOpen, setIsArchiveOpen] = useState(false);
    const [isChartOpen, setIsChartOpen] = useState(false);
    const sensorKey = `${type}${index}`;

    // دریافت نام سفارشی
    const customName = customNames[index];

    // ۱. پارس کردن خروجی‌های متصل
    const activeRelays = settings?.toDOut ? settings.toDOut.split(',').map(Number).filter(n => !isNaN(n)) : [];

    // مدیریت تغییر نام
    const handleSaveName = () => {
        if (onSaveCustomName) {
            onSaveCustomName(index, editedName.trim());
        }
        setIsEditingName(false);
    };

    const startEditingName = (e) => {
        e.stopPropagation();
        setEditedName(customName || '');
        setIsEditingName(true);
    };

    const toggleRelay = (relayId) => {
        let newRelays;
        if (activeRelays.includes(relayId)) {
            newRelays = activeRelays.filter(r => r !== relayId);
        } else {
            newRelays = [...activeRelays, relayId].sort((a, b) => a - b);
        }
        onUpdate('toDOut', newRelays.join(','));
    };

    const handleKeyDown = (e, prop) => {
        if (e.key === 'Enter') {
            onUpdate(prop, e.target.value);
            e.target.blur();
        }
    };

    const relayCount = isExpanded ? 72 : 8;
    const relayList = [...Array(relayCount).keys()];

    return (
        <div className={styles.sensorCard} style={{ position: 'relative' }}>
            {/* --- هدر با قابلیت ویرایش --- */}
            <div className={styles.cardHeader}>
                <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                    {icon}
                    <span style={{fontWeight:'bold'}}>
                        {customName ? (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: '14px', color: '#f1c40f' }}>{customName}</span>
                                <span style={{ fontSize: '10px', color: '#7f8c8d' }}>{label}</span>
                            </div>
                        ) : (
                            label
                        )}
                    </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <div
        onClick={(e) => {
            e.stopPropagation();
            setIsArchiveOpen(true);
        }}
        title="مشاهده آرشیو جدولی"
        style={{ cursor: 'pointer', color: '#2ecc71', opacity: 0.9 }}
    >
        <FaTable size={13} />
    </div>
     <div
        onClick={(e) => {
            e.stopPropagation();
            setIsChartOpen(true);
        }}
        title="مشاهده نمودار"
        style={{ cursor: 'pointer', color: '#f1c40f', opacity: 0.95 }}
    >
        <FaChartLine size={14} />
    </div>
    <div
        onClick={startEditingName}
        title="ویرایش نام"
        style={{ cursor: 'pointer', color: '#3498db', opacity: 0.7 }}
    >
        <FaEdit size={12} />
    </div>
</div>
            </div>

            {/* مدال کوچک ویرایش نام */}
            {/* مدال ویرایش نام - کاملاً هماهنگ با DigitalInputCard */}
            {isEditingName && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#2c3e50',
                    padding: '15px',
                    borderRadius: '8px',
                    zIndex: 100,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    minWidth: '200px'
                }}>
                    <div style={{ marginBottom: '10px', fontSize: '12px', color: '#ccc' }}>
                        ویرایش نام {label}
                    </div>
                    <input
                        type="text"
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        placeholder="نام جدید را وارد کنید..."
                        style={{
                            width: '100%',
                            padding: '8px 5px',
                            borderRadius: '4px',
                            border: '1px solid #34495e',
                            backgroundColor: '#1a252f',
                            color: '#f1c40f',
                            marginBottom: '10px',
                            outline: 'none'
                        }}
                        autoFocus
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') handleSaveName();
                            if (e.key === 'Escape') setIsEditingName(false);
                        }}
                    />
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                        <button 
                            onClick={() => setIsEditingName(false)} 
                            style={{ padding: '5px 10px', backgroundColor: '#7f8c8d', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer', fontSize: '11px' }}
                        >
                            لغو
                        </button>
                        <button 
                            onClick={handleSaveName} 
                            style={{ padding: '5px 10px', backgroundColor: '#2ecc71', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer', fontSize: '11px' }}
                        >
                            ذخیره
                        </button>
                    </div>
                </div>
            )}

            <div className={styles.liveValueContainer}>
                <FaLightbulb className={`${styles.trigIcon} ${triggered ? styles.trigOn : styles.trigOff}`} />
                <div className={styles.liveValue}>
                    {current} <span className={styles.unit}>{unit}</span>
                </div>
            </div>

            <div className={styles.settingsGroup}>
                <div className={styles.settingRow}>
                    <span>نقطه تنظیم (Set):</span>
                    <input className={styles.inputNum} defaultValue={settings.setpoint} onBlur={(e) => onUpdate('setpoint', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'setpoint')} />
                </div>
                
                <div className={styles.settingRow}>
                    <span>هیسترزیس:</span>
                    <input className={styles.inputNum} defaultValue={settings.hyster} onBlur={(e) => onUpdate('hyster', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'hyster')} />
                </div>

                {/* سایر بخش‌های تنظیمات (بدون تغییر نسبت به کد شما) */}
                <div className={styles.settingRow}>
                    <span>تاخیر وصل/قطع:</span>
                    <div style={{display:'flex', gap:'4px'}}>
                        <input className={styles.inputNum} placeholder="Lead" defaultValue={settings.leadDelay} onBlur={(e) => onUpdate('leadDelay', e.target.value)} />
                        <input className={styles.inputNum} placeholder="Lag" defaultValue={settings.lagDelay} onBlur={(e) => onUpdate('lagDelay', e.target.value)} />
                    </div>
                </div>

                <div style={{display:'flex', justifyContent:'space-between', margin:'10px 0'}}>
                    <div className={styles.settingRow} style={{border:'none', padding:0}}>
                        <span style={{fontSize:'12px'}}>معکوس:</span>
                        <label className={styles.toggleSwitch}>
                            <input type="checkbox" checked={settings.reverse === "1"} onChange={(e) => onUpdate('reverse', e.target.checked ? "1" : "0")} />
                            <span className={styles.slider}></span>
                        </label>
                    </div>
                    <div className={styles.settingRow} style={{border:'none', padding:0}}>
                        <span style={{fontSize:'12px'}}>پیامک:</span>
                        <label className={styles.toggleSwitch}>
                            <input type="checkbox" checked={settings.alertSms === "1"} onChange={(e) => onUpdate('alertSms', e.target.checked ? "1" : "0")} />
                            <span className={styles.slider}></span>
                        </label>
                    </div>
                </div>

                {/* انتخاب‌گر رله‌ها */}
                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start', borderTop: '1px solid #ffffff10', paddingTop: '10px' }}>
                    <span style={{fontSize:'13px', color:'#3498db', marginBottom:'8px'}}>خروجی‌های متصل:</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', padding: '6px', background: 'rgba(0,0,0,0.2)', borderRadius: '4px', width: '100%' }}>
                        {relayList.map(r => (
                            <button key={r} type="button" onClick={() => toggleRelay(r)}
                                style={{
                                    width: '22px', height: '22px', fontSize: '9px',
                                    backgroundColor: activeRelays.includes(r) ? '#2ecc71' : '#34495e',
                                    border: 'none', color: 'white', borderRadius: '3px', cursor: 'pointer'
                                }}>
                                {r}
                            </button>
                        ))}
                        <button type="button" onClick={() => setIsExpanded(!isExpanded)}
                            style={{ width: '22px', height: '22px', background: '#e67e22', border: 'none', borderRadius: '3px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                            {isExpanded ? <FaMinus size={8} /> : <FaPlus size={8} />}
                        </button>
                    </div>
                </div>
            </div>
            <ArchiveTableModal
                isOpen={isArchiveOpen}
                onClose={() => setIsArchiveOpen(false)}
                serial={serial}
                sensorKey={sensorKey}
                title={customName || label}
                token={token}
            />
            <ArchiveChartModal
              isOpen={isChartOpen}
              onClose={() => setIsChartOpen(false)}
              serial={serial}
              sensorKey={sensorKey}
              title={customName || label}
              unit={unit}
/>
        </div>
    );
};

export default SensorControlCard;